<template>
    <div ref="fullscreenContainer" style="background-color: #eceff1;">
        <v-container fluid> 
            <v-dialog v-model="showFullscreenPrompt" persistent max-width="400">
                <v-card class="fullscreen-card">
                    <v-card-title class="justify-center text-h5">Modo fullscreen necessário</v-card-title>
                    <v-card-text class="text-center">
                        Para uma melhor experiência, clique no botão abaixo para ativar o modo de tela cheia.
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="primary" @click="ativarFullscreen" large block>Ativar Fullscreen</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-row class="justify-center mb-4">
                <v-img
                    max-width="180px"
                    src="../assets/sesi-logo.png"
                    style="cursor: pointer;"
                ></v-img>
            </v-row>

            <v-row class="justify-center mb-4">
                <h4 class="text-center primary--text font-weight-bold">
                    {{ unidadeSelecionada }}
                </h4>
            </v-row>
            <v-row class="justify-center mb-4">
                <v-card class="pa-5 justify-center" outlined height="auto" min-width="700px">
                        <v-row class="justify-center mb-4">
                            <h2 class="text-center primary--text font-weight-bold">
                                Pesquisa de satisfação do atendimento
                            </h2>
                        </v-row>

                        <v-row class="justify-center mb-6">                            
                            <v-col
                                v-for="opcao in opcoes"
                                :key="opcao.IdOpcao"
                                cols="6" 
                                sm="2"
                                class="text-center d-flex flex-column align-center"
                            >
                                <v-avatar
                                    size="90"
                                    :color="getColor(opcao.IdOpcao)"
                                    class="elevation-3 sentiment-icon mb-2"
                                    :class="{ 
                                        'selected-sentiment': opcao.IdOpcao === IdOpcaoSelecionada, 
                                        'unselected-sentiment': IdOpcaoSelecionada !== null && opcao.IdOpcao !== IdOpcaoSelecionada 
                                    }"
                                    @click="selecionarOpcao(opcao.IdOpcao)"
                                    style="cursor: pointer;"
                                >
                                    <v-icon size="60" dark>
                                        {{ getIcon(opcao.IdOpcao) }}
                                    </v-icon>
                                </v-avatar>

                                <span class="option-label primary--text font-weight-bold">
                                    {{ opcao.Opcao }}
                                </span>
                            </v-col>                        
                        </v-row>

                        <v-row class="justify-center">
                            <v-col cols="12" md="12" lg="10">
                                <v-textarea
                                    v-model="observacao"
                                    label="Observações"
                                    outlined
                                    rows="5"
                                    clearable
                                    class="white-background"
                                ></v-textarea>
                            </v-col>
                        </v-row>

                        <v-row class="justify-center">
                            <v-col cols="6">
                                <v-btn
                                    color="primary"
                                    @click="enviarResposta"
                                    :loading="loading"
                                    large
                                    height="50px"
                                    width="200px"
                                    class="mx-auto my-4"
                                    block
                                    dark
                                >
                                    Enviar
                                </v-btn>
                            </v-col>
                        </v-row>
                </v-card>
            </v-row>
            <AlertSystem :snackbar="system.snackbar"></AlertSystem>
        </v-container>
    </div>
</template>

<script>
import axios from 'axios';
import AlertSystem from "../components/AlertSystem";

export default {
    components:{
        AlertSystem,
    },
    data() {
        return {
            unidadeSelecionada: this.$route.query.Unidade || 'Unidade não informada',
            IdUnidade: this.$route.query.IdUnidade,
            IdOpcaoSelecionada: null,
            observacao: '',
            loading: false,
            opcoes: [],
            system: {
                snackbar: {},
            },
            showFullscreenPrompt: false,
        };
    },
    methods: {
        async fetchOpcoes() {
            try {
                const response = await axios.get('/pesquisa/opcoes');
                this.opcoes = response.data;
            } catch (error) {
                this.system.snackbar = {
                    snackbar: true,
                    text: 'Não foi possível carregar as opções de pesquisa. Tente novamente mais tarde.',
                    color: "red",
                };
            }
        },
        verificarFullscreen() {
            const isFullscreen =
                document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement;
            this.showFullscreenPrompt = !isFullscreen; 
        },
        ativarFullscreen() {
            const element = this.$refs.fullscreenContainer;
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
        },
        getIcon(id) {
            const icons = {
                1: 'mdi-emoticon-excited', // ÓTIMO
                2: 'mdi-emoticon-happy',   // BOM
                3: 'mdi-emoticon-neutral', // REGULAR
                4: 'mdi-emoticon-sad',     // RUIM
                5: 'mdi-emoticon-angry',   // PÉSSIMO
            };
            return icons[id] || 'mdi-help-circle';
        },        
        getColor(id) {
            const colors = {
                1: '#2E7D32', // Verde Escuro (Ótimo)
                2: '#66BB6A', // Verde Claro (Bom)
                3: '#FFA726', // Laranja (Regular)
                4: '#EF5350', // Vermelho Claro (Ruim)
                5: '#C62828', // Vermelho Escuro (Péssimo)
            };
            return colors[id] || 'grey';
        },
        selecionarOpcao(id) {
            this.IdOpcaoSelecionada = id;
        },
        async enviarResposta() {
            if (!this.IdOpcaoSelecionada) {
                this.system.snackbar = {
                    snackbar: true,
                    text: 'Por favor, selecione uma opção antes de enviar.',
                    color: "red",
                };
                return;
            }

            this.loading = true;

            const payload = {
                IdUnidade: this.IdUnidade,
                IdOpcao: this.IdOpcaoSelecionada,
                observacao: this.observacao,
            };

            try {
                await axios.post('/pesquisa', payload);
                this.system.snackbar = {
                    snackbar: true,
                    text: 'Resposta enviada com sucesso!',
                    color: "green",
                };                
            } catch (error) {
                this.system.snackbar = {
                    snackbar: true,
                    text: 'Erro ao enviar a resposta. Tente novamente.',
                    color: "red",
                };
            } finally {
                this.IdOpcaoSelecionada = null
                this.observacao = null
                this.loading = false
            }  
        },
    },
    mounted() {
        this.fetchOpcoes();
        this.ativarFullscreen();
        this.verificarFullscreen();
        document.addEventListener("fullscreenchange", this.verificarFullscreen);
    },
    beforeDestroy() {
        document.removeEventListener("fullscreenchange", this.verificarFullscreen);
    },
};

</script>

<style scoped>
.v-card {
    min-width: 400px;
    border-radius: 15px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.selected-button {
    border: 4px solid #ffeb3b;
    background-color: rgba(255, 235, 59, 0.2);
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.7);
    transform: scale(1.1);
}

.disabled-button {
    filter: grayscale(90%);
    opacity: 0.7;
}

.option-button {
    color: white !important;
}

.option-label {
    display: block;
    font-size: 0.85rem;
    line-height: 1.2;
    text-transform: uppercase;
    word-wrap: break-word;
    max-width: 120px;
    min-height: 40px;
}

.white-background .v-textarea__content {
    background-color: #fff;
}

.v-col {
    padding: 10px !important;
}

.sentiment-icon {
    transition: all 0.2s ease-in-out;
}

.sentiment-icon:hover {
    transform: translateY(-5px);
    filter: brightness(1.1);
}

.selected-sentiment {
    outline: 5px solid #FFD600; /* Um amarelo mais vivo */
    transform: scale(1.1);
}

.unselected-sentiment {
    filter: grayscale(80%);
    opacity: 0.5;
    transform: scale(0.9);
}

</style>
